export const REAGION_SOATO = [
  {
    id: 'fd85f201-7079-4628-9591-dc91095d21b9',
    soato: 1735,
    name: 'Qoraqalpog`iston Respublikasi',
  },
  {
    id: '4eb8a483-f15a-4b93-adf3-256d32c7942c',
    soato: 1703,
    name: 'Andijon viloyati',
  },
  {
    id: '519115bf-6dbb-4088-88e8-9c42a5d65f58',
    soato: 1706,
    name: 'Buxoro viloyati',
  },

  {
    id: '57c7539e-9f0a-4e05-993b-7c55ded13283',
    soato: 1708,
    name: 'Jizzax viloyati',
  },
  {
    id: '9a723b63-915f-4e98-a5aa-74c13e7cbb34',
    soato: 1710,
    name: 'Qashqadaryo viloyati',
  },
  {
    id: 'fe85efb5-a3bc-4067-8a80-bc391f440943',
    soato: 1712,
    name: 'Navoiy viloyati',
  },
  {
    id: '724e7fa1-25b1-4c24-bf85-c7805b1ed59a',
    soato: 1714,
    name: 'Namangan viloyati',
  },
  {
    id: 'e18cf4d6-0991-429a-b551-bb2786ac3008',
    soato: 1718,
    name: 'Samarqand viloyati',
  },
  {
    id: 'f464bb2f-2154-4c02-9b98-f04223bd0416',
    soato: 1722,
    name: 'Surxandaryo viloyati',
  },
  {
    id: 'e9c4002c-a099-4f19-92dc-5ca734fe7866',
    soato: 1724,
    name: 'Sirdaryo viloyati',
  },
  {
    id: 'e13d2c95-0f37-4fcf-bda8-104b04e3b346',
    soato: 1727,
    name: 'Toshkent viloyati',
  },
  {
    id: '54151f47-1788-4f32-a0ed-787096eb2984',
    soato: 1730,
    name: 'Farg`ona viloyati',
  },
  {
    id: '97b0cd89-fe69-4265-a9dc-8f56357b9f23',
    soato: 1733,
    name: 'Xorazm viloyati',
  },
];
